import React from 'react';
import { llmsTxt, robotsTxt, sitemapXml } from '../lib/llms';
import { Seo } from '../components/Seo';
type Document = 'llms' | 'robots' | 'sitemap';
const BUILDERS: Record<Document, {
  title: string;
  build: () => string;
}> = {
  llms: {
    title: 'llms.txt',
    build: llmsTxt
  },
  robots: {
    title: 'robots.txt',
    build: robotsTxt
  },
  sitemap: {
    title: 'sitemap.xml',
    build: sitemapXml
  }
};

/**
 * The machine readable files, rendered as text.
 *
 * A single page application cannot serve a response with a text/plain or
 * application/xml content type, so these routes exist so the content is
 * reachable, reviewable and copyable now, and so the strings live in code rather
 * than in a document. On the Next.js build they become app/llms.txt/route.ts,
 * app/robots.ts and app/sitemap.ts, calling the same builders in lib/llms.ts.
 */
export function MachineReadable({
  document: doc
}: {
  document: Document;
}) {
  const {
    title,
    build
  } = BUILDERS[doc];
  const content = build();
  return <>
      <Seo title={title} description={`The ${title} file for Cavalla Solution, shown as text.`} path={`/${title}`} noIndex data-id="element-2760" data-mp="2z7ji972bblto" />
      <div className="min-h-screen w-full bg-charcoal px-5 py-10 sm:px-8" data-id="element-2761" data-mp="2ubclo4vt3moe">
        <p className="mb-6 text-small text-muted" data-id="element-2762" data-mp="397ttim4sej67">
          {title}. On the Next.js build this is served with the correct content type from a route handler.
        </p>
        <pre className="max-w-4xl whitespace-pre-wrap break-words font-mono text-[13px] leading-relaxed text-body" data-id="element-2763" data-mp="3i65n8x0y9x2v">
          {content}
        </pre>
      </div>
    </>;
}